const passwordsMatch = (val1: string, val2: string): boolean => val1 === val2 && val1 !== '';

export default passwordsMatch;
